import {
	BN,
	VelocityClient,
	PerpMarketConfig,
	User,
	ZERO,
	SlotDurationMs,
} from '@velocity-exchange/sdk';
import { OpenPosition, getOpenPositionData } from '@velocity-exchange/common';
import { PositionsResult } from './types';

export function computePositions(
	user: User,
	velocityClient: VelocityClient,
	perpMarketsLookup: PerpMarketConfig[],
	slotDuration: SlotDurationMs,
	markPriceCallback: (marketIndex: number) => BN
): PositionsResult {
	if (perpMarketsLookup.length === 0) {
		return {
			openPerpPositions: [],
			totalUnsettledPnl: ZERO,
			marketsNeedingSettlement: [],
		};
	}

	const userAccountPositions = user.getUserAccountOrThrow().perpPositions;

	let openPerpPositions: OpenPosition[];
	try {
		openPerpPositions = getOpenPositionData(
			velocityClient,
			userAccountPositions,
			user,
			perpMarketsLookup,
			slotDuration,
			markPriceCallback
		);
	} catch (error) {
		console.error('Error getting open positions:', error);
		openPerpPositions = [];
	}

	const totalUnsettledPnl = openPerpPositions.reduce(
		(a, b) => a.add(b.unsettledPnl),
		ZERO
	);

	const totalUnrealizedPnl = openPerpPositions.reduce(
		(a, b) => a.add(b.totalUnrealizedPnl),
		ZERO
	);

	let marketsNeedingSettlement: number[] = [];
	if (totalUnsettledPnl.lt(totalUnrealizedPnl)) {
		marketsNeedingSettlement = openPerpPositions
			.filter((pos) => pos.totalUnrealizedPnl.gt(pos.unsettledPnl))
			.map((pos) => ({
				diff: pos.totalUnrealizedPnl.sub(pos.unsettledPnl),
				marketIndex: pos.marketIndex,
			}))
			.sort((a, b) => b.diff.toNumber() - a.diff.toNumber())
			.map((val) => val.marketIndex);
	}

	return {
		openPerpPositions,
		totalUnsettledPnl,
		marketsNeedingSettlement,
	};
}
